export default __webpack_public_path__ + "static/media/59_mobile.08f0cf36.jpg";